// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"a566101e","outerContainer":"_7a5feaec","secondaryToolbar":"cd5d94a9","doorHangerRight":"_96534b98","toolbarContainer":"fe090f4d","toolbarViewerMiddle":"_8a135053","progressBar":"_0dacba1f","back-to-application":"_5ce68565","paperStyles":"_87bd9d35","iconStyles":"_61f7cc79","buttonStyles":"_7ab2cf22"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/VideoCallEndPopup/styles.styl
// module id = 5170
// module chunks = 39